import React from 'react';
import Title from '@pro/activity/testerClub/Title';
import Products from '@pro/activity/testerClub/Products';
import Tabs from '@pro/activity/testerClub/Tabs';
import Rules from '@pro/activity/testerClub/Rules';
import styles from '@app/activity/testerClub/index.module.less';
import cn from 'classnames';
import { IServerProps } from '@pro/activity/testerClub/interface';
import { useEarlyAccess } from '@pro/activity/testerClub/useEarlyAccess';
import { observer } from 'base/store';
import { EggHunt } from '@pro/common/EggHunt';
import TesterReviews from '@app/activity/testerClub/TesterReviews';

type IProps = {
    serverProps: IServerProps;
}

const Page: Globals.NextPage<IProps> = observer((props) => {

    const earlyAccess = useEarlyAccess({ serverProps: props.serverProps })

    return (
        <>
            <div className={cn(styles['main-container'], 'wrapper')}>
                <Title/>

                <Tabs earlyAccess={earlyAccess}/>

                <Products earlyAccess={earlyAccess}/>
            </div>

            <TesterReviews
                className={styles['tester-reviews-wrap']}
                earlyAccess={earlyAccess}
            />

            <Rules className={styles['rules-wrap']}/>

            <EggHunt/>
        </>
    );
});

Page.pageConf = {
    pageCode: 'testerClub',
};

export { getServerSideProps } from '@pro/activity/testerClub/services';

export default Page